<template>
  <div class="vg-content">
    <van-image class="logo" width="100" height="50" :src="srcLogo"/>
    <div v-if="userType === 'guard'" class="slogan">欢迎使用 电子出入证 - 管理</div>
    <div v-else class="slogan">欢迎使用 电子出入证</div>
    <div class="entry">
      <span class="title">手机号</span>
      <van-field class="text" v-model="userPhone" type="tel" placeholder="请输入手机号" :maxlength="11" :border="false"
                 center/>
    </div>
    <div class="entry">
      <span class="title">验证码</span>
      <div class="content">
        <van-field class="code" v-model="verifyCode" type="digit" placeholder="请输入验证码" :maxlength="4"
                   :border="false" center/>
        <div class="get-code" :class="{disabled: isGetCode}" @click="onGetCode">{{ strGetCode }}</div>
      </div>
    </div>
    <vg-button class="button" type="primary" @click="onSubmit">登录</vg-button>
    <vg-button v-if="userType === 'guard'" class="button" type="primary" @click="onSubmitSaml">凯德员工登录</vg-button>
    <div class="register" :style="showRegister?'visibility: visible':'visibility: hidden'" @click="onRegister">
      注册账号
    </div>

    <div class="footer">
      <van-checkbox v-model="checked" icon-size="20px">已阅读并同意
        <span style="color: #4BA9F6;" @click.stop="userAgreement">《用户协议》</span> 和
        <span style="color: #4BA9F6;" @click.stop="privacyPolicy">《隐私政策》</span>
      </van-checkbox>
    </div>
  </div>
</template>

<script>
import {Checkbox, Field, Image as VanImage, Toast,} from 'vant';
import srcLogo from "@/assets/login/kaidelogo.png";
import {client} from "@/libraries/http";
import VgButton from "@/components/Commons/VgButton";
import validate from "@/filters/validate";
// import {mapState} from "pinia/dist/pinia.esm-browser";
import useAuthnStore from "@/store/authn";

export default {
  components: {
    VanImage, VgButton, "van-field": Field, "van-checkbox": Checkbox,
  },
  data() {
    return {
      srcLogo: srcLogo,
      userPhone: "",
      verifyCode: "",
      isGetCode: false,
      strGetCode: "获取验证码",
      checked: false,
      userType: "guard",
    }
  },
  computed: {
    // ...mapState(useAuthnStore, ['code', 'authorization','user']),
    showRegister() {
      return this.userType !== "guard" && this.userType !== "respondent"
    },
  },
  created() {
    console.log(this.$route);
    this.userType = this.$route.query.type;
    //若存在token自动跳转
    const authn = useAuthnStore();
    if (authn.authorization) {
      if (this.userType === "guard") {
        this.$router.replace({path: '/scanVerify/scanVerify'});
      } else {
        this.$router.replace({path: '/myElectronicPass'});
      }
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    onSubmitSaml() {
      if (!this.checked) {
        Toast("请先阅读并同意协议");
        return;
      }
      window.location = process.env.VUE_APP_LOGIN_URL + 'saml/h5/index';
    },
    onSubmit() {
      console.log(this.userType);
      if (!this.checkInput(true)) {
        return;
      }
      if (this.userType === "guard") {
        this.loginGuard();
      } else {
        this.login();
      }
    },
    onGetCode() {
      if (this.isGetCode) {
        return;
      }
      if (!this.checkInput(false)) {
        return;
      }
      // let params = {
      //     phoneNumber: this.userPhone,
      //     type: this.userType === "guard" ? "1" : "",
      // };
      // client.post("/api/public/login/exist", params)
      // .then(() => {
      let params = {
        account: this.userPhone,
        bizType: "LONGIN",
      };
      client.post("/api/public/verifycode", params)
      .then(() => {
        Toast.success('发送成功');
        this.isGetCode = true;
        this.strGetCode = "60秒倒计时";
        this.count = 60;
        this.timer = setInterval(() => this.countDown(), 1000);
      })
    },
    countDown() {
      this.count--;
      if (this.count > 0) {
        this.strGetCode = this.count + "秒倒计时";
      } else {
        clearInterval(this.timer);
        this.isGetCode = false;
        this.strGetCode = "获取验证码";
      }
    },
    onRegister() {
      this.$router.push({path: '/register'});
    },
    userAgreement() {
      // this.$router.push({path: '/userAgreement'});
      window.location.href = process.env.VUE_APP_ROUTER_BASE_URL + 'user-agreement-1.0.html'
    },
    privacyPolicy() {
      // this.$router.push({path: '/privacyPolicy'});
      window.location.href = process.env.VUE_APP_ROUTER_BASE_URL + 'privacy-policy-1.0.html'
    },
    checkInput(isSubmit) {
      if (!this.userPhone) {
        Toast("请输入手机号");
        return false;
      }
      if (!validate.isPhone(this.userPhone)) {
        Toast("手机号格式不正确，请重新输入");
        return false;
      }
      if (isSubmit && !this.verifyCode) {
        Toast("请输入验证码");
        return false;
      }
      if (isSubmit && !this.checked) {
        Toast("请先阅读并同意协议");
        return false;
      }
      return true;
    },
    loginGuard() {
      let params = {
        phoneNumber: this.userPhone,
        code: this.verifyCode,
      };
      client.post("/api/public/login/guard", params).then(res => {
        console.log(res);
        const authn = useAuthnStore();
        authn.token({
          token: res.data.token,
          user: {
            loginType: res.data.loginType,
            userName: res.data.userName,
            userPhone: res.data.userPhone
          }
        });
        this.$router.replace({path: '/scanVerify/scanVerify'});
      })
    },
    login() {
      let params = {
        phoneNumber: this.userPhone,
        code: this.verifyCode,
        loginType: '1'
      };
      client.post("/api/public/login", params).then(res => {
        const authn = useAuthnStore();
        authn.token({
          login: true,
          token: res.data.token,
          user: {
            loginType: res.data.loginType,
            userName: res.data.userName,
            userPhone: res.data.userPhone
          }
        });
        this.$router.replace({path: '/myElectronicPass'});
      })
    },
  },
}
</script>

<style scoped>
.vg-content {
  background-color: #FFFFFF;
  padding: 30px 40px 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 100vh;
}

.logo {
  align-self: flex-start;
}

.slogan {
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: bold;
  color: #101010;
  font-size: 22px;
}

.entry {
  margin: 15px 0px 0px;
  display: flex;
  flex-direction: column;
}

.title {
  margin-top: 0px;
  color: #101010;
  font-size: 14px;
}

.text {
  margin-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
  color: #101010;
  font-size: 16px;
  border-bottom: 1px solid #E5E5EA;
}

.content {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E5E5EA;
}

.code {
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
  color: #101010;
  font-size: 16px;
}

.get-code {
  margin-left: 15px;
  color: #4BA9F6;
  font-size: 14px;
  flex-shrink: 0;
}

.disabled {
  color: #B4B4B4;
}

::v-deep .van-field__control::placeholder {
  color: #AEAEB2 !important;
}

::v-deep .van-field__control::-webkit-input-placeholder { /* 使用webkit内核的浏览器 */
  color: #AEAEB2 !important;
}

::v-deep .van-field__control:-moz-placeholder { /* Firefox版本4-18 */
  color: #AEAEB2 !important;
}

::v-deep .van-field__control::-moz-placeholder { /* Firefox版本19+ */
  color: #AEAEB2 !important;
}

::v-deep .van-field__control:-ms-input-placeholder { /* IE浏览器 */
  color: #AEAEB2 !important;
}

.button {
  margin-top: 20px;
  height: 44px;
}

.register {
  margin-top: 20px;
  align-self: center;
  color: #4BA9F6;
  font-size: 14px;
}

.footer {
  margin-top: 30px;
  color: #101010;
  font-size: 12px;
  align-self: center;
}
</style>
